import { PluginNameEnum } from './plugin-name-enum'
import { NoticeDataTypeEnum } from './notice-data-type-enum'

export interface NoticeDetailInterface {
  /**
   * 提醒类型
   */
  noticeType?: PluginNameEnum | null
  /**
   * 数据类型
   *  - event - 日程
   *  - email - 邮件
   *  - message - 消息
   *  - todo - 待办
   */
  dataType?: NoticeDataTypeEnum | null
  /**
   * 日程-开始时间
   *  - seiue
   *  - 企业邮箱
   */
  startTime?: string | null
  /**
   * 日程-结束时间
   *  - seiue
   *  - 企业邮箱
   */
  endTime?: string | null
  /**
   * 日程-标题
   *  - seiue
   *  - 企业邮箱
   */
  title?: string | null
  /**
   * 日程-描述
   *  - seiue
   *  - 企业邮箱
   */
  description?: string | null
  /**
   * 日程-地点
   *  - seiue
   *  - 企业邮箱
   */
  address?: string | null
  /**
   * 唯一标识
   */
  uid?: string | null
  /**
   * 是否已读
   */
  isRead?: boolean | null
  /**
   * 发件人
   *  - 企业邮箱
   */
  from?: string | null
  /**
   * 发送时间
   *  - 企业邮箱
   */
  sentDate?: string | null
}

export class NoticeDetail implements NoticeDetailInterface {
  /**
   * 提醒类型
   */
  noticeType?: PluginNameEnum | null
  /**
   * 数据类型
   *  - event - 日程
   *  - email - 邮件
   *  - message - 消息
   *  - todo - 待办
   */
  dataType?: NoticeDataTypeEnum | null
  /**
   * 日程-开始时间
   *  - seiue
   *  - 企业邮箱
   */
  startTime?: string | null
  /**
   * 日程-结束时间
   *  - seiue
   *  - 企业邮箱
   */
  endTime?: string | null
  /**
   * 日程-标题
   *  - seiue
   *  - 企业邮箱
   */
  title?: string | null
  /**
   * 日程-描述
   *  - seiue
   *  - 企业邮箱
   */
  description?: string | null
  /**
   * 日程-地点
   *  - seiue
   *  - 企业邮箱
   */
  address?: string | null
  /**
   * 唯一标识
   */
  uid?: string | null
  /**
   * 是否已读
   */
  isRead?: boolean | null
  /**
   * 发件人
   *  - 企业邮箱
   */
  from?: string | null
  /**
   * 发送时间
   *  - 企业邮箱
   */
  sentDate?: string | null

  constructor(props: NoticeDetailInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      noticeType: _noticeType,
      dataType: _dataType,
      startTime: _startTime,
      endTime: _endTime,
      title: _title,
      description: _description,
      address: _address,
      uid: _uid,
      isRead: _isRead,
      from: _from,
      sentDate: _sentDate,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.noticeType = _noticeType
    this.dataType = _dataType
    this.startTime = _startTime
    this.endTime = _endTime
    this.title = _title
    this.description = _description
    this.address = _address
    this.uid = _uid
    this.isRead = _isRead
    this.from = _from
    this.sentDate = _sentDate
  }
}
